import { createReducer, on } from '@ngrx/store';
import * as ProductsActions from './products.actions';
import { initialProductsState } from './products.state';

export const productsReducer = createReducer(
  initialProductsState,

  on(ProductsActions.loadProducts, (state, { params }) => ({
    ...state,
    params: { ...state.params, ...params },
    loading: true,
    error: null,
  })),

  on(ProductsActions.loadProductsSuccess, (state, { response }) => ({
    ...state,
    products: response.items,
    total: response.total,
    page: response.page,
    limit: response.limit,
    totalPages: response.totalPages,
    loading: false,
    error: null,
  })),

  on(ProductsActions.loadProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductsActions.createProduct, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductsActions.createProductSuccess, (state, { product }) => ({
    ...state,
    products: [ ...state.products, product ],
    loading: false,
    error: null,
  })),

  on(ProductsActions.createProductFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductsActions.updateProduct, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductsActions.updateProductSuccess, (state, { product }) => ({
    ...state,
    products: state.products.map(item => item.id === product.id ? product : item),
    loading: false,
    error: null,
  })),

  on(ProductsActions.updateProductFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductsActions.deleteProduct, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductsActions.deleteProductSuccess, (state, { id }) => ({
    ...state,
    products: state.products.filter(item => item.id !== id),
    loading: false,
    error: null,
  })),

  on(ProductsActions.deleteProductFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
